import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCustomerData } from "@cinch-labs/customer-data-segment";
import styles from "./sale-promo-banner.module.css";
export function SalePromoBanner(param) {
    var sendDigitalDataEvent = param.sendDigitalDataEvent;
    var trackEvent = useCustomerData().trackEvent;
    var handleOnClick = function() {
        var data = {
            event: {
                name: "click",
                category: "link",
                action: "navigate",
                label: "shop sale now"
            }
        };
        trackEvent({
            type: "track",
            eventName: "Promotion Clicked",
            data: {
                name: "Sale promo banner - cars on offer",
                position: "top banner"
            }
        });
        if (sendDigitalDataEvent) sendDigitalDataEvent(data);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.saveTag,
                children: "SHOP"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: styles.text,
                children: [
                    "Price reductions on",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "/used-cars?tags=cars-on-offer",
                        onClick: handleOnClick,
                        children: "selected cars"
                    }),
                    ", from \xa3250 - \xa31000 off"
                ]
            })
        ]
    });
}
export default SalePromoBanner;
